<div class="row mt-3" *ngIf="locationList && locationList.length>0">
  <div class="col-12">
    <b>{{locationList.length}}&nbsp;</b>
    <span>location result<span *ngIf="locationList.length > 1">s</span></span>
  </div>
  <div class="table-responsive mt-3 col-sm-12 no-gutter">
    <table class="table table-striped tbl-scrollable">
      <thead class="thead-light">
        <tr>
          <!-- <th scope="col" width="10%" class="text-center"><button class="btn btn-outline-danger pt-0 pb-0"
              [disabled]="selectedLocations.length < 1" data-toggle="modal" data-target="#deleteLocation"><i
                class="fa fa-trash"></i></button>
          </th> -->
          <th scope="col" width="23%" class="d-none d-xl-table-cell">Location ID</th>
          <th scope="col" width="17%">Name</th>
          <th scope="col" width="30%">Address</th>
          <th class="text-center" width="10%" scope="col" style="word-break: normal">Active Vehicles</th>
          <th class="text-center" width="10%" scope="col" style="word-break: normal">Home</th>
          <th class="text-center" width="10%" scope="col" style="word-break: normal">Away</th>
          <th class="text-center" width="10%" scope="col" style="word-break: normal">Remote</th>
        </tr>
      </thead>
      <tbody class="max-height-57">
        <!-- class="cursor-pointer" [routerLink]="['/location/detail']" [queryParams]="{id: location.id}" -->
        <tr *ngFor="let location of locationList; let i = index" (click)="updateLocationClick(location)">
          <!-- <th scope="row" class="text-center pr-0">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" name="checkbox" class="custom-control-input"
                [disabled]="location.vehiclesAtHomeLocation + location.vehiclesAtAwayLocation + location.vehiclesFromAwayLocation != 0 "
                id="location_{{i}}" (change)="onLocationSelected(location.id)">
              <label class="custom-control-label" for="location_{{i}}"></label>
            </div>
          </th> -->
          <td width="23%" class="d-none d-xl-table-cell cursor-pointer">{{location.id}}</td>
          <td width="17%" class="cursor-pointer">{{location.address.name}}</td>
          <td width="30%" class="cursor-pointer"><span
              *ngIf="location.address.street">{{location.address.street}},&nbsp;</span><span
              *ngIf="location.address.line1">{{location.address.line1}},&nbsp;</span><span
              *ngIf="location.address.line2">{{location.address.line2}},&nbsp;</span><span
              *ngIf="location.address.city">{{location.address.city}},&nbsp;</span><span
              *ngIf="location.address.state">{{location.address.state}},&nbsp;</span><span
              *ngIf="location.address.country">{{location.address.country}},&nbsp;</span>{{location.address.zipCode}}
          </td>
          <td width="10%" class="text-center cursor-pointer">
            {{location.vehiclesAtHomeLocation + location.vehiclesAtAwayLocation}}</td>
          <td width="10%" class="text-center cursor-pointer">
            {{location.vehiclesAtHomeLocation}}</td>
          <td width="10%" class="text-center cursor-pointer">
            {{location.vehiclesAtAwayLocation}}</td>
          <td width="10%" class="text-center cursor-pointer">
            {{location.vehiclesFromAwayLocation}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Hodden button to open update model -->
<button id="updateLocation" class="btn btn-primary mr-3" data-toggle="modal" data-target="#addLocationModal"
  data-backdrop="static" data-keyboard="false" hidden="true">Update Location</button>


<!-- Modal Add/Update A Location -->
<div class="modal fade" id="addLocationModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="addLocationTitle">
          <span>Update Location</span>
        </h5>
        <button type="button" id="closeAddLocationModal" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form #addLocationForm="ngForm" novalidate (ngSubmit)="onCreateLocation(addLocationForm)">
        <div class="modal-body pt-1">
          <div class="row mt-1">
            <div class="col-12">
              <div class="form-group mb-1">
                <label>Location Name</label>
                <input type="text" class="form-control" [(ngModel)]="locationFormData.address.name" name="locName"
                  #locName="ngModel">
              </div>

              <div class="form-group mb-1">
                <label><span class="maroon  astrisk">&#10033;&nbsp;</span>Street
                  Address</label>
                <input type="text" class="form-control" [(ngModel)]="locationFormData.address.street" name="street"
                  #street="ngModel" required>
                <small class="text-danger text-center" *ngIf="street.errors && addLocationForm.submitted">
                  <p class="mb-0" *ngIf="street.errors.required">*Required</p>
                </small>
              </div>

              <div class="row">
                <div class="col">
                  <div class="form-group mb-1">
                    <label><span class="maroon  astrisk">&#10033;&nbsp;</span>Zip-Code</label>
                    <input type="text" class="form-control" [(ngModel)]="locationFormData.address.zipCode"
                      name="zipCode" #zipCode="ngModel" pattern="[0-9]{5}" maxlength="5"
                      (input)="getZipCodeDetails($event.target.value)" required>
                    <small class="text-danger text-center" *ngIf="zipCode.errors && addLocationForm.submitted">
                      <p class="mb-0" *ngIf="zipCode.errors.required">*Required</p>
                      <p class="mb-0" *ngIf="!zipCode.errors.required && !invalidZipCode">Invalid Zip-Code</p>
                    </small>
                    <small class="text-danger text-center" *ngIf="invalidZipCode">
                      <p class="mb-0">Invalid Zip-Code</p>
                    </small>
                  </div>
                </div>
                <div class="col">
                  <div class="form-group mb-1">
                    <label><span class="maroon astrisk">&#10033;&nbsp;</span>State</label>
                    <select id="model" class="w-100" aria-placeholder="Select State"
                      [(ngModel)]="locationFormData.address.state" name="state"
                      #state="ngModel" required>
                      <option [ngValue]="null">Select State</option>
                      <option *ngFor="let state of stateList" value={{state}}>{{state}}</option>
                    </select>
                    <small class="text-danger text-center" *ngIf="state.errors && addLocationForm.submitted">
                      <p class="mb-0" *ngIf="state.errors.required">*Required</p>
                    </small>
                  </div>
                </div>
              </div>

              <div class="form-group  mb-1">
                <label><span class="maroon  astrisk">&#10033;&nbsp;</span>City</label>
                <input type="text" class="form-control" [(ngModel)]="locationFormData.address.city" name="city"
                  #city="ngModel" required>
                <small class="text-danger text-center" *ngIf="city.errors && addLocationForm.submitted">
                  <p class="mb-0" *ngIf="city.errors.required">*Required</p>
                </small>
              </div>

              <label class="heading mt-2 mb-2">Location Coordinates ( &#176; )</label>
              <div class="row">
                <div class="col">
                  <div class="form-group mb-1">
                    <label>Latitude</label>
                    <input type="number" class="form-control" [(ngModel)]="locationFormData.coordinate.latitude"
                      name="latitude" #latitude="ngModel"
                      pattern="^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,6})?))$">
                    <small class="text-danger text-center" *ngIf="latitude.errors && addLocationForm.submitted">
                      <p class="mb-0" *ngIf="!latitude.errors.required">Invalid Latitude</p>
                    </small>
                  </div>
                </div>
                <div class="col">
                  <div class="form-group mb-1">
                    <label>Longitude</label>
                    <input type="number" class="form-control" [(ngModel)]="locationFormData.coordinate.longitude"
                      name="longitude" #longitude="ngModel"
                      pattern="^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,6})?))$">
                    <small class="text-danger text-center" *ngIf="longitude.errors && addLocationForm.submitted">
                      <p class="mb-0" *ngIf="!longitude.errors.required">Invalid Longitude</p>
                    </small>
                  </div>
                </div>
              </div>
              <div>
                <small class="text-danger text-center" *ngIf="addLocationForm.submitted">
                  <p class="mb-0"
                    *ngIf="(latitude.dirty && longitude.value == null) || (longitude.dirty && latitude.value == null)">
                    Provide both the coordinates or none.</p>
                </small>
              </div>

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light btn-80" data-dismiss="modal" (click)="resetLocationForm()">CANCEL</button>
          <button type="submit" class="btn btn-primary border btn-80">Save</button>
        </div>
      </form>
    </div>
  </div>
</div>